import axios from 'axios'
import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'
import networkWrapper from '../utils/networkWrapper'
import api from '../api'

import routerActions from './router'

const prefix = 'user'

const initialState = {
  loaded: false,
  data: null,
  token: '',
}

const reducers = {
  setData: (state, action) => {
    state.loaded = true
    state.data = action.payload || null
  },
  setToken: (state, action) => {
    state.token = action.payload
  },
}

const loaders = {

  status: () => axios.get(api.url('/auth/status'))
    .then(api.process),

  getToken: () => axios.get(api.url('/auth/token'))
    .then(api.process),
 
  logout: () => axios.post(api.url('/auth/logout'))
    .then(api.process),

  updateMeta: (data) => axios.put(api.url('/user/meta'), data)
    .then(api.process),
    
}

const sideEffects = {

  loadStatus: () => networkWrapper({
    prefix,
    name: 'status',
    handler: async (dispatch, getState) => {
      const data = await loaders.status()
      dispatch(actions.setData(data))
    },
  }),

  loadToken: () => networkWrapper({
    prefix,
    name: 'loadToken',
    handler: async (dispatch, getState) => {
      const data = await loaders.getToken()
      dispatch(actions.setToken(data.token))
    },
  }),

  logout: () => networkWrapper({
    prefix,
    name: 'logout',
    handler: async (dispatch, getState) => {
      await loaders.logout()
      const data = await loaders.status()
      dispatch(actions.setData(data))
      dispatch(routerActions.navigateTo('login'))
    },
  }),

  updateMeta: (data) => networkWrapper({
    prefix,
    name: 'updateMeta',
    handler: async (dispatch, getState) => {
      const result = await loaders.updateMeta(data)
      dispatch(actions.setData(result))
    },
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  sideEffects,
  prefix,
})

export {
  actions,
  reducer,
}

export default actions